import React from 'react';
import "./YourBrand.css";

export default function YourBrand() {
    return (
        <div className="rice-branding-container">
            <h2 className="rice-branding-title" data-aos="fade-up">
                Your Rice, Your Brand – Powered by Our Private Labeling
            </h2>
            <p className="rice-branding-description" data-aos="fade-up">
                We help you launch your own rice brand with premium-quality grains, custom packaging, and complete support —
                from farm to shelf. Whether it's Basmati, Sona Masoori, or Long Grain Rice, we bring your brand vision to
                life.
            </p>
        </div>
    )
}